export default class LocalStorage {
  static PREFIX = "verse-player:";

  static get isSupported() {
    try {
      return typeof window !== "undefined" && window.localStorage;
    } catch (error) {
      if (error.name === "SecurityError") {
        // LocalStorage is blocked due to cookie policy.
        return false;
      }
      throw error;
    }
  }

  static set(key, value) {
    if (!this.isSupported) {
      return false;
    }

    window.localStorage[this.PREFIX + key] = value;
  }

  static get(key, options) {
    if (!this.isSupported) {
      return options.defaultValue;
    }

    let val = window.localStorage[this.PREFIX + key];

    if (typeof val === "undefined") {
      val = options.defaultValue;
    }

    if (typeof val === "number" || typeof val === "boolean") {
      return val.toString();
    }

    return val;
  }

  static getBool(key, options) {
    return this.get(key, options) === "true";
  }
}
